import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";
import {
  GET_ALL_COUNTRY_DATA,
  GET_COUNTRY_BASIC_INFO,
  GET_COUNTRY_EXCHANGES,
  GET_COUNTRY_REGULATORS,
  GET_COUNTRY_APPROVERS,
  GET_COUNTRY_RISK_DATA,
  GET_COUNTRY_RISK_DATA_RANGES,
  GET_GEOGRAPHIES,
  ADD_COUNTRY,
  UPDATE_COUNTRY,
  ADD_EXCHANGE,
  ADD_REGULATOR,
  UPDATE_EXCHANGE,
  UPDATE_REGULATOR,
  UPDATE_COUNTRY_DATA_RANGE,
  GET_LANGUAGES,
  GET_COUNTRY_LANGUAGES,
} from "./graphql";

const getCountries = async () => {
  const response = await client.query({
    query: GET_ALL_COUNTRY_DATA,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getCountries");
  return results;
};

const getCountriesWithContacts = async () => {
  const response = await client.query({
    query: GET_COUNTRY_BASIC_INFO,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getCountriesWithContacts");
  return results;
};

const getCountryExchanges = async () => {
  const response = await client.query({
    query: GET_COUNTRY_EXCHANGES,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getExchangeList");
  return results;
};

const getCountryApprovers = async () => {
  const response = await client.query({
    query: GET_COUNTRY_APPROVERS,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getCountryApprovers");
  return results;
};

const addCountryExchange = async (params) => {
  const response = await client.query({
    query: ADD_EXCHANGE,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "addExchange");
  return results;
};

const updateCountryExchange = async (params) => {
  const response = await client.query({
    query: UPDATE_EXCHANGE,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "updateExchange");
  return results;
};

const getCountryRegulators = async () => {
  const response = await client.query({
    query: GET_COUNTRY_REGULATORS,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getRegulatorsList");
  return results;
};

const addCountryRegulator = async (params) => {
  const response = await client.query({
    query: ADD_REGULATOR,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "addRegulator");
  return results;
};

const updateCountryRegulator = async (params) => {
  const response = await client.query({
    query: UPDATE_REGULATOR,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "updateRegulator");
  return results;
};

const getCountryRiskData = async (countryId) => {
  const response = await client.query({
    query: GET_COUNTRY_RISK_DATA,
    variables: {
      countryId,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getCountryRiskData");
  return results;
};

const getCountryRiskDataRanges = async () => {
  const response = await client.query({
    query: GET_COUNTRY_RISK_DATA_RANGES,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getCountryRiskDataRanges");
  return results;
};

const updateCountryRiskDataRange = async (params) => {
  const response = await client.query({
    query: UPDATE_COUNTRY_DATA_RANGE,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "updateCountryRiskDataRange");
  return results;
};

const getGeographies = async () => {
  const response = await client.query({
    query: GET_GEOGRAPHIES,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getGeographies");
  return results;
};

const addCountry = async (params) => {
  const response = await client.query({
    query: ADD_COUNTRY,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "addCountry");
  return results;
};

const updateCountry = async (params) => {
  const response = await client.query({
    query: UPDATE_COUNTRY,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "updateCountry");
  return results;
};

const getLanguages = async () => {
  const response = await client.query({
    query: GET_LANGUAGES,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getLanguages");
  return results;
};

const getLanguagesByCountryCode = async (countryIsoCode2) => {
  const response = await client.query({
    query: GET_COUNTRY_LANGUAGES,
    variables: {
      countryIsoCode2,
    },
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getLanguagesByCountryCode");
  return results;
};

export {
  getCountries,
  getCountriesWithContacts,
  getCountryExchanges,
  getCountryRegulators,
  getCountryApprovers,
  getCountryRiskData,
  getCountryRiskDataRanges,
  getGeographies,
  addCountry,
  updateCountry,
  addCountryExchange,
  addCountryRegulator,
  updateCountryExchange,
  updateCountryRegulator,
  updateCountryRiskDataRange,
  getLanguages,
  getLanguagesByCountryCode,
};
